export default __webpack_public_path__ + "static/media/splash-player-left.dd77401f.svg";